import { Absent_getInstance17o8jlyfouexf as Absent_getInstance } from '../../../../../../../apollo-kotlin-apollo-api/com/apollographql/apollo/api/Optional.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
import {
  toString1pkumu07cwy4m as toString,
  getStringHashCode26igk1bx568vk as getStringHashCode,
  hashCodeq5arwsb9dgti as hashCode,
  equals2au1ep9vhcato as equals,
} from '../../../../../../../kotlin-kotlin-stdlib/kotlin/js/coreRuntime.mjs';
import { initMetadataForClassbxx6q50dy2s7 as initMetadataForClass } from '../../../../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
//region block: imports
var imul = Math.imul;
//endregion
//region block: pre-declaration
//endregion
var PinnedPlayerInputClass;
function PinnedPlayerInput() {
  if (PinnedPlayerInputClass === VOID) {
    class $ {
      constructor(id, name, email, badge, callSignAdjective, callSignNoun, imageURL, avatarType, unvalidatedEmails, pins) {
        badge = badge === VOID ? Absent_getInstance() : badge;
        imageURL = imageURL === VOID ? Absent_getInstance() : imageURL;
        avatarType = avatarType === VOID ? Absent_getInstance() : avatarType;
        this.t6q_1 = id;
        this.u6q_1 = name;
        this.v6q_1 = email;
        this.w6q_1 = badge;
        this.x6q_1 = callSignAdjective;
        this.y6q_1 = callSignNoun;
        this.z6q_1 = imageURL;
        this.a6r_1 = avatarType;
        this.b6r_1 = unvalidatedEmails;
        this.c6r_1 = pins;
      }
      toString() {
        return 'PinnedPlayerInput(id=' + this.t6q_1.toString() + ', name=' + this.u6q_1 + ', email=' + this.v6q_1 + ', badge=' + toString(this.w6q_1) + ', callSignAdjective=' + this.x6q_1 + ', callSignNoun=' + this.y6q_1 + ', imageURL=' + toString(this.z6q_1) + ', avatarType=' + toString(this.a6r_1) + ', unvalidatedEmails=' + toString(this.b6r_1) + ', pins=' + toString(this.c6r_1) + ')';
      }
      hashCode() {
        var result = this.t6q_1.hashCode();
        result = imul(result, 31) + getStringHashCode(this.u6q_1) | 0;
        result = imul(result, 31) + getStringHashCode(this.v6q_1) | 0;
        result = imul(result, 31) + hashCode(this.w6q_1) | 0;
        result = imul(result, 31) + getStringHashCode(this.x6q_1) | 0;
        result = imul(result, 31) + getStringHashCode(this.y6q_1) | 0;
        result = imul(result, 31) + hashCode(this.z6q_1) | 0;
        result = imul(result, 31) + hashCode(this.a6r_1) | 0;
        result = imul(result, 31) + hashCode(this.b6r_1) | 0;
        result = imul(result, 31) + hashCode(this.c6r_1) | 0;
        return result;
      }
      equals(other) {
        if (this === other)
          return true;
        if (!(other instanceof PinnedPlayerInput()))
          return false;
        if (!this.t6q_1.equals(other.t6q_1))
          return false;
        if (!(this.u6q_1 === other.u6q_1))
          return false;
        if (!(this.v6q_1 === other.v6q_1))
          return false;
        if (!equals(this.w6q_1, other.w6q_1))
          return false;
        if (!(this.x6q_1 === other.x6q_1))
          return false;
        if (!(this.y6q_1 === other.y6q_1))
          return false;
        if (!equals(this.z6q_1, other.z6q_1))
          return false;
        if (!equals(this.a6r_1, other.a6r_1))
          return false;
        if (!equals(this.b6r_1, other.b6r_1))
          return false;
        if (!equals(this.c6r_1, other.c6r_1))
          return false;
        return true;
      }
    }
    initMetadataForClass($, 'PinnedPlayerInput');
    PinnedPlayerInputClass = $;
  }
  return PinnedPlayerInputClass;
}
//region block: exports
export {
  PinnedPlayerInput as PinnedPlayerInput1hnlnl1bk4or8,
};
//endregion

//# sourceMappingURL=PinnedPlayerInput.mjs.map
